import React from 'react';
import RazorpayCheckout from './RazorpayCheckout';

const PaymentGatewayPlaceholder = () => {
  return <RazorpayCheckout />;
};

export default PaymentGatewayPlaceholder;
